import Catalog from './Catalog'
import Archive from './Archive'
import Filter from './Filter'
import Product from './Product'

export default {
  install (Vue) {
    const repositories = {
      catalog: new Catalog(),
      filter: new Filter(),
      archive: new Archive(),
      product: new Product()
    }

    Vue.prototype.$api = repositories
  }
}
